import React from "react";

import recaptcha from "~/lib/recaptcha";

import useSaveEventMutation from "./useSaveEventMutation";

export default function useMoveEventMutation() {
	const saveEvent = useSaveEventMutation();
	return React.useCallback(
		async ({
			calendarId,
			guid,
			title,
			start,
			end,
			isAllDay,
		}: {
			calendarId: string;
			guid: string;
			title: string;
			start: Date;
			end: Date;
			isAllDay: boolean;
		}) => {
			const captchaToken = await recaptcha("useMoveEventMutation");

			return await saveEvent({
				calendar: calendarId,
				guid,
				title,
				start: start.toISOString(),
				end: end.toISOString(),
				isAllDay,
				captchaToken,
			});
		},
		[saveEvent],
	);
}
